// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__2Z7db","main":"Error_main__26_8H","ttl":"Error_ttl__3jHTu","txt":"Error_txt__1X3lD","btn":"Error_btn__3GxG5"};